import React from 'react'

const Button = (props) => {
  return (
    <button type={props.type} onClick={props.onClick} className={"p-2 flex justify-center items-center h-10 rounded-[20px] text-center cursor-pointer " + props.className}>{props.children}</button>
  )
}

export default Button